@if (isGoogleMapsLoaded) {
<google-map height="{{mapConfig.size.height}}" width="{{mapConfig.size.width}}" [zoom]="mapConfig.zoom.initialValue"
  [center]="center" [options]="options">
  @for (marker of markers; track marker) {
  <map-marker [position]="marker.position" [label]="marker.label" [title]="marker.title" [options]="marker.options"
    (mapClick)="openInfo(marker, marker.info)">
  </map-marker>
  }
  <map-info-window>{{ infoContent }}</map-info-window>
</google-map>
}